const validator = (properties: Record<string, any>) => {
  const errors: string[] = [];

  // Validate credentialId
  if (!properties.credentialId) {
    errors.push('Turso credentials are required');
  }

  // Validate operation
  if (!properties.operation) {
    errors.push('Operation is required');
  }

  // Validate query for executeQuery and executeStatement operations
  if (
    (properties.operation === 'executeQuery' ||
      properties.operation === 'executeStatement') &&
    !properties.query
  ) {
    errors.push('SQL query is required');
  }

  // Validate queries for batch operation
  if (properties.operation === 'batch') {
    if (!properties.queries || !Array.isArray(properties.queries)) {
      errors.push('Batch queries must be an array');
    } else if (properties.queries.length === 0) {
      errors.push('At least one query is required for batch operation');
    } else {
      // Validate each query in batch
      properties.queries.forEach((q: any, index: number) => {
        if (!q.sql) {
          errors.push(`Query ${index + 1} in batch is missing sql property`);
        }
      });
    }
  }

  // Validate parameters if provided
  if (
    properties.parameters &&
    !Array.isArray(properties.parameters) &&
    typeof properties.parameters !== 'string'
  ) {
    errors.push('Parameters must be an array or a string expression');
  }

  return {
    valid: errors.length === 0,
    errors,
  };
};

export default validator;
